@if (animalSpecies().length > 0) {
  <div class="container">
    <mat-form-field>
      <mat-label>{{ props?.label ?? 'Animal Species' }}</mat-label>
      <input
        #input
        matInput
        [id]="id"
        [name]="field.name"
        [readonly]="props?.readonly"
        [required]="props?.required"
        [errorStateMatcher]="matcher"
        [formlyAttributes]="field"
        [tabIndex]="props?.tabindex"
        [placeholder]="props?.placeholder ?? 'Pick one'"
        type="text"
        [formControl]="formControl"
        [matAutocomplete]="autocomplete"
        (input)="search.set(input.value)"
        (focus)="search.set(input.value)"
      />
      @if (!field.formControl.disabled && formControl.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="formControl.setValue(null); $event.stopPropagation()"
          aria-label="Clear selection"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-autocomplete
        requireSelection
        #autocomplete="matAutocomplete"
        [displayWith]="displayFn()"
      >
        <mat-option value="Other"> -- Other -- </mat-option>
        @for (option of filteredOptions(); track option.id) {
          @let notice = protectiveBeltNotice(option);
          <mat-option [value]="option.id" [class.option-with-notice]="notice">
            @if (notice) {
              <mat-icon class="protective-belt-icon" aria-label="Protective belt warning"
                >warning</mat-icon
              >
            }
            {{ option.english }}
            @if (notice) {
              <span class="protective-belt-notice">{{ notice }}</span>
            }
          </mat-option>
        }
      </mat-autocomplete>
      @if (showError) {
        <mat-error>
          <formly-validation-message [field]="field"></formly-validation-message>
        </mat-error>
      }
    </mat-form-field>
    @if (props?.reloadBtn) {
      <button mat-icon-button (click)="reload()" matTooltip="Reload" color="primary">
        <mat-icon>autorenew</mat-icon>
      </button>
    }
  </div>
  @if (protectiveBeltWarning(); as warning) {
    <div class="alert alert-warning protective-belt-alert" role="alert">
      <mat-icon class="protective-belt-icon" aria-hidden="true">warning</mat-icon>
      <span>{{ warning }}</span>
    </div>
  }
}
